// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ai-assistant {
  --ai-brand-1: #2b3991;
  --ai-brand-2: #1e71bb;
  --ai-brand-3: #6d5dfc;
  --ai-gradient: linear-gradient(135deg, #2b3991 0%, #1e71bb 55%, #4f8ff0 100%);
  --ai-gradient-rich: linear-gradient(135deg, #1f2a78 0%, #3b3fc4 45%, #1e71bb 100%);
  --ai-ink: #0f172a;
  --ai-ink-soft: #475569;
  --ai-ink-muted: #94a3b8;
  --ai-line: rgba(15, 23, 42, 0.08);
  --ai-surface: #ffffff;
  --ai-ease: cubic-bezier(0.22, 1, 0.36, 1);

  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  color: var(--ai-ink);
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  overflow: hidden;
  background:
    radial-gradient(900px 420px at 0% -10%, rgba(79, 143, 240, 0.14), transparent 60%),
    radial-gradient(700px 380px at 110% 10%, rgba(109, 93, 252, 0.12), transparent 60%),
    linear-gradient(180deg, #f8faff 0%, #f3f5fb 100%);
}

/* ---------- Header ---------- */

.ai-assistant__header {
  position: relative;
  z-index: 5;
  padding: 0 20px;
  height: 68px;
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: saturate(180%) blur(16px);
  -webkit-backdrop-filter: saturate(180%) blur(16px);
  border-bottom: 1px solid var(--ai-line);
}

.ai-assistant__header-content {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.ai-assistant__logo-area {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex: 1 1;
}

.ai-assistant__logo-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #ffffff;
  font-size: 18px;
  background: var(--ai-gradient-rich);
  box-shadow:
    0 6px 16px rgba(43, 57, 145, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.25);
}

.ai-assistant__logo-text-wrap {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.ai-assistant__logo-text {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--ai-ink);
  line-height: 1.2;
}

.ai-assistant__online {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11.5px;
  font-weight: 500;
  color: #059669;
  line-height: 1;
}

.ai-assistant__online-dot {
  position: relative;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #10b981;
}

.ai-assistant__online-dot::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: #10b981;
  animation: ai-assistant-pulse 2s var(--ai-ease) infinite;
}

.ai-assistant__header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  position: relative;
}

.ai-assistant__history-wrap {
  position: relative;
}

.ai-assistant__history-btn,
.ai-assistant__close-btn {
  width: 38px;
  height: 38px;
  border: 1px solid var(--ai-line);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.9);
  color: var(--ai-ink-soft);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  flex-shrink: 0;
  padding: 0;
  position: relative;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  transition:
    background-color 0.25s var(--ai-ease),
    color 0.25s var(--ai-ease),
    border-color 0.25s var(--ai-ease),
    transform 0.25s var(--ai-ease),
    box-shadow 0.25s var(--ai-ease);
}

.ai-assistant__history-btn:hover,
.ai-assistant__history-btn--active {
  background: #ffffff;
  color: var(--ai-brand-1);
  border-color: rgba(43, 57, 145, 0.22);
  box-shadow: 0 6px 16px rgba(43, 57, 145, 0.12);
  transform: translateY(-1px);
}

.ai-assistant__close-btn:hover {
  background: #ffffff;
  color: var(--ai-ink);
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.1);
  transform: translateY(-1px) rotate(90deg);
}

.ai-assistant__history-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: linear-gradient(135deg, #f43f5e, #e11d48);
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
  box-shadow: 0 0 0 2px #ffffff, 0 4px 10px rgba(225, 29, 72, 0.35);
}

/* ---------- History panel ---------- */

.ai-assistant__history-panel {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  width: min(340px, calc(100vw - 48px));
  max-height: min(400px, 60vh);
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid var(--ai-line);
  border-radius: 16px;
  box-shadow:
    0 24px 48px -12px rgba(15, 23, 42, 0.22),
    0 4px 12px rgba(15, 23, 42, 0.06);
  z-index: 30;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transform-origin: top right;
  animation: ai-assistant-pop 0.28s var(--ai-ease);
}

.ai-assistant__history-panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--ai-line);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--ai-ink);
}

.ai-assistant__history-clear {
  border: none;
  background: rgba(43, 57, 145, 0.08);
  color: var(--ai-brand-1);
  font-size: 11.5px;
  font-weight: 600;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 999px;
  transition: background-color 0.2s var(--ai-ease);
}

.ai-assistant__history-clear:hover {
  background: rgba(43, 57, 145, 0.14);
}

.ai-assistant__history-empty {
  padding: 28px 16px;
  font-size: 12.5px;
  color: var(--ai-ink-muted);
  text-align: center;
  line-height: 1.6;
}

.ai-assistant__history-list {
  list-style: none;
  margin: 0;
  padding: 8px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ai-assistant__history-item {
  display: flex;
  align-items: stretch;
  gap: 2px;
  border-radius: 10px;
  transition: background-color 0.2s var(--ai-ease);
}

.ai-assistant__history-item:hover {
  background: rgba(43, 57, 145, 0.05);
}

.ai-assistant__history-item-main {
  flex: 1 1;
  min-width: 0;
  border: none;
  background: transparent;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px;
  cursor: pointer;
  text-align: left;
  color: inherit;
}

.ai-assistant__history-item-main:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.ai-assistant__history-item-main > i {
  width: 26px;
  height: 26px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(43, 57, 145, 0.08);
  color: var(--ai-brand-1);
  font-size: 11px;
  flex-shrink: 0;
}

.ai-assistant__history-item-body {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.ai-assistant__history-item-text {
  font-size: 12.5px;
  font-weight: 500;
  color: var(--ai-ink);
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.ai-assistant__history-item-time {
  font-size: 10.5px;
  color: var(--ai-ink-muted);
}

.ai-assistant__history-item-remove {
  width: 30px;
  border: none;
  background: transparent;
  color: var(--ai-ink-muted);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  flex-shrink: 0;
  padding: 0;
  opacity: 0;
  transition: opacity 0.2s var(--ai-ease), color 0.2s, background-color 0.2s;
}

.ai-assistant__history-item:hover .ai-assistant__history-item-remove {
  opacity: 1;
}

.ai-assistant__history-item-remove:hover {
  color: #e11d48;
  background: #fff1f2;
}

/* ---------- Main / chat ---------- */

.ai-assistant__main {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  justify-content: center;
  padding: 28px 0 12px;
  width: 100%;
  overscroll-behavior: contain;
  scroll-behavior: smooth;
}

.ai-assistant__chat-wrapper {
  width: 100%;
  max-width: 720px;
  padding: 0 24px 8px;
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.ai-assistant__footer > form,
.ai-assistant__header-content {
  max-width: 720px;
  margin: 0 auto;
  width: 100%;
}

/* ---------- Welcome ---------- */

.ai-assistant__welcome {
  min-height: 58vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 12px 4px;
  animation: ai-assistant-rise 0.6s var(--ai-ease);
}

.ai-assistant__welcome-icon {
  position: relative;
  width: 76px;
  height: 76px;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 26px;
  color: #ffffff;
  font-size: 32px;
  background: var(--ai-gradient-rich);
  box-shadow:
    0 18px 40px -8px rgba(43, 57, 145, 0.5),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
  animation:
    ai-assistant-float 5s ease-in-out infinite,
    ai-assistant-glow 3.2s ease-in-out infinite;
}

.ai-assistant__welcome-title {
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -0.03em;
  margin: 0 0 10px;
  line-height: 1.2;
  background: linear-gradient(135deg, #0f172a 0%, #2b3991 60%, #1e71bb 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

.ai-assistant__welcome-subtitle {
  margin: 0;
  max-width: 440px;
  font-size: 14px;
  line-height: 1.65;
  color: var(--ai-ink-soft);
}

.ai-assistant__welcome-subtitle strong {
  color: var(--ai-brand-1);
  font-weight: 600;
}

.ai-assistant__suggestions {
  margin-top: 28px;
  width: 100%;
  max-width: 480px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.ai-assistant__suggestion {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  text-align: left;
  border: 1px solid var(--ai-line);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.85);
  color: var(--ai-ink);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  opacity: 0;
  animation: ai-assistant-rise 0.55s var(--ai-ease) forwards;
  transition:
    transform 0.3s var(--ai-ease),
    box-shadow 0.3s var(--ai-ease),
    border-color 0.3s var(--ai-ease),
    background-color 0.3s var(--ai-ease);
}

.ai-assistant__suggestion:nth-child(1) { animation-delay: 0.08s; }
.ai-assistant__suggestion:nth-child(2) { animation-delay: 0.14s; }
.ai-assistant__suggestion:nth-child(3) { animation-delay: 0.2s; }
.ai-assistant__suggestion:nth-child(4) { animation-delay: 0.26s; }

.ai-assistant__suggestion:hover {
  background: #ffffff;
  border-color: rgba(43, 57, 145, 0.22);
  transform: translateY(-2px);
  box-shadow: 0 12px 24px -8px rgba(43, 57, 145, 0.22);
}

.ai-assistant__suggestion-icon {
  width: 30px;
  height: 30px;
  border-radius: 9px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: var(--ai-brand-1);
  background: linear-gradient(135deg, rgba(43, 57, 145, 0.1), rgba(30, 113, 187, 0.12));
  transition: background 0.3s var(--ai-ease), color 0.3s var(--ai-ease);
}

.ai-assistant__suggestion:hover .ai-assistant__suggestion-icon {
  background: var(--ai-gradient);
  color: #ffffff;
}

.ai-assistant__suggestion-text {
  flex: 1 1;
  min-width: 0;
  line-height: 1.35;
}

.ai-assistant__suggestion-arrow {
  font-size: 12px;
  color: var(--ai-ink-muted);
  opacity: 0;
  transform: translate(-4px, 4px);
  transition: opacity 0.3s var(--ai-ease), transform 0.3s var(--ai-ease), color 0.3s;
}

.ai-assistant__suggestion:hover .ai-assistant__suggestion-arrow {
  opacity: 1;
  color: var(--ai-brand-1);
  transform: translate(0, 0);
}

/* ---------- Messages ---------- */

.ai-assistant__message-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  animation: ai-assistant-rise 0.45s var(--ai-ease);
}

.ai-assistant__message-row--user {
  justify-content: flex-end;
  align-items: flex-end;
}

.ai-assistant__message-row--ai {
  justify-content: flex-start;
}

.ai-assistant__message-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-width: 85%;
  min-width: 0;
}

.ai-assistant__message-content--user {
  align-items: flex-end;
}

.ai-assistant__msg-actions {
  display: flex;
  gap: 2px;
  padding-right: 2px;
  opacity: 0;
  transform: translateY(-2px);
  transition: opacity 0.25s var(--ai-ease), transform 0.25s var(--ai-ease);
}

.ai-assistant__message-row--user:hover .ai-assistant__msg-actions {
  opacity: 1;
  transform: translateY(0);
}

.ai-assistant__msg-actions--ai {
  opacity: 1;
  transform: none;
  padding-left: 2px;
}

.ai-assistant__action-btn {
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 9px;
  background: transparent;
  color: var(--ai-ink-muted);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  padding: 0;
  transition: background-color 0.2s var(--ai-ease), color 0.2s var(--ai-ease);
}

.ai-assistant__action-btn:hover {
  background-color: rgba(43, 57, 145, 0.08);
  color: var(--ai-brand-1);
}

.ai-assistant__action-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.ai-assistant__label {
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: var(--ai-ink-muted);
  padding-left: 4px;
}

.ai-assistant__label--user {
  text-align: right;
  padding-right: 4px;
}

.ai-assistant__label--ai {
  color: var(--ai-brand-1);
}

.ai-assistant__avatar {
  width: 34px;
  height: 34px;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  flex-shrink: 0;
  color: #ffffff;
  background: var(--ai-gradient-rich);
  box-shadow: 0 6px 14px -4px rgba(43, 57, 145, 0.45);
}

.ai-assistant__bubble {
  padding: 13px 18px;
  border-radius: 20px 20px 20px 6px;
  max-width: 100%;
  font-size: 14.5px;
  line-height: 1.65;
  white-space: pre-wrap;
  word-break: break-word;
}

.ai-assistant__bubble--user {
  background: var(--ai-gradient);
  border-radius: 20px 20px 6px 20px;
  line-height: 1.55;
  color: #ffffff;
  box-shadow:
    0 10px 24px -8px rgba(43, 57, 145, 0.5),
    inset 0 1px 0 rgba(255, 255, 255, 0.18);
}

.ai-assistant__bubble--ai {
  background: var(--ai-surface);
  color: var(--ai-ink);
  border: 1px solid var(--ai-line);
  box-shadow:
    0 1px 2px rgba(15, 23, 42, 0.04),
    0 8px 24px -12px rgba(15, 23, 42, 0.12);
}

.ai-assistant__typewriter {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ai-assistant__typewriter-line {
  animation: ai-assistant-line-reveal 0.35s var(--ai-ease);
  line-height: 1.65;
}

.ai-assistant__md-heading {
  font-weight: 700;
  letter-spacing: -0.015em;
  color: var(--ai-ink);
  margin: 8px 0 4px;
  line-height: 1.35;
}

.ai-assistant__md-heading--h1 { font-size: 19px; }
.ai-assistant__md-heading--h2 { font-size: 17px; }
.ai-assistant__md-heading--h3 { font-size: 15.5px; }
.ai-assistant__md-heading--h4 { font-size: 14.5px; }

.ai-assistant__md-paragraph {
  font-size: 14.5px;
  line-height: 1.65;
  color: #1e293b;
}

.ai-assistant__md-paragraph strong,
.ai-assistant__md-bullet strong {
  color: var(--ai-ink);
  font-weight: 650;
}

.ai-assistant__md-bullet {
  display: flex;
  gap: 10px;
  font-size: 14.5px;
  line-height: 1.65;
  color: #1e293b;
  padding-left: 2px;
}

.ai-assistant__md-bullet-dot {
  flex-shrink: 0;
  width: 6px;
  height: 6px;
  margin-top: 0.62em;
  border-radius: 50%;
  background: var(--ai-gradient);
  font-size: 0;
}

.ai-assistant__md-bullet-num {
  color: var(--ai-brand-1);
  flex-shrink: 0;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  line-height: 1.65;
}

.ai-assistant__md-bullet-text {
  flex: 1 1;
  min-width: 0;
}

.ai-assistant__md-spacer {
  height: 8px;
}

.ai-assistant__inline-code {
  background-color: rgba(43, 57, 145, 0.06);
  border: 1px solid rgba(43, 57, 145, 0.12);
  border-radius: 6px;
  padding: 1px 6px;
  font-family: "JetBrains Mono", "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
  font-size: 12.5px;
  color: #3b3fc4;
}

.ai-assistant__cursor {
  display: inline-block;
  width: 7px;
  height: 7px;
  margin: 6px 0 0 2px;
  border-radius: 50%;
  background: var(--ai-gradient);
  animation: ai-assistant-cursor-pulse 1s ease-in-out infinite;
}

/* ---------- Thinking ---------- */

.ai-assistant__thinking {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

.ai-assistant__thinking-text {
  font-size: 14px;
  font-weight: 500;
  background: linear-gradient(90deg, #b6c0d4 20%, #2b3991 50%, #b6c0d4 80%);
  background-size: 200% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  animation: ai-assistant-shimmer 1.8s linear infinite;
}

.ai-assistant__thinking-dots {
  display: inline-flex;
  align-items: flex-end;
  gap: 4px;
  margin-left: 6px;
  padding-bottom: 3px;
}

.ai-assistant__thinking-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--ai-gradient);
  opacity: 0.35;
  animation: ai-assistant-think-dot 1.4s ease-in-out infinite;
}

.ai-assistant__thinking-dot:nth-child(2) { animation-delay: 0.2s; }
.ai-assistant__thinking-dot:nth-child(3) { animation-delay: 0.4s; }

/* ---------- Footer / composer ---------- */

.ai-assistant__footer {
  position: relative;
  padding: 10px 18px 14px;
  flex-shrink: 0;
  background: linear-gradient(180deg, rgba(243, 245, 251, 0) 0%, #f3f5fb 40%);
}

.ai-assistant__input-wrapper,
.ai-assistant__record-wrapper {
  background: var(--ai-surface);
  border: 1px solid rgba(15, 23, 42, 0.1);
  border-radius: 20px;
  padding: 8px;
  display: flex;
  box-shadow:
    0 1px 2px rgba(15, 23, 42, 0.04),
    0 16px 36px -14px rgba(15, 23, 42, 0.18);
  transition: border-color 0.3s var(--ai-ease), box-shadow 0.3s var(--ai-ease);
}

.ai-assistant__input-wrapper {
  align-items: flex-end;
}

.ai-assistant__input-wrapper:focus-within {
  border-color: rgba(43, 57, 145, 0.35);
  box-shadow:
    0 0 0 4px rgba(43, 57, 145, 0.08),
    0 16px 36px -14px rgba(43, 57, 145, 0.3);
}

.ai-assistant__textarea {
  flex: 1 1;
  background-color: transparent;
  border: none;
  outline: none;
  color: var(--ai-ink);
  font-size: 14.5px;
  resize: none;
  padding: 10px 12px;
  font-family: inherit;
  line-height: 1.5;
  max-height: 140px;
  overflow-y: auto;
}

.ai-assistant__textarea::placeholder {
  color: var(--ai-ink-muted);
}

.ai-assistant__mic-btn {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border: none;
  border-radius: 12px;
  background: transparent;
  color: var(--ai-ink-soft);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  margin-left: 4px;
  transition: background-color 0.2s var(--ai-ease), color 0.2s var(--ai-ease);
}

.ai-assistant__mic-btn:hover {
  background: rgba(43, 57, 145, 0.08);
  color: var(--ai-brand-1);
}

.ai-assistant__send-btn {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--ai-gradient-rich);
  color: #ffffff;
  border: none;
  border-radius: 12px;
  font-size: 17px;
  cursor: pointer;
  margin-left: 6px;
  box-shadow:
    0 8px 18px -6px rgba(43, 57, 145, 0.6),
    inset 0 1px 0 rgba(255, 255, 255, 0.25);
  transition:
    transform 0.25s var(--ai-ease),
    box-shadow 0.25s var(--ai-ease),
    opacity 0.25s var(--ai-ease),
    background 0.25s var(--ai-ease);
}

.ai-assistant__send-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow:
    0 12px 22px -6px rgba(43, 57, 145, 0.7),
    inset 0 1px 0 rgba(255, 255, 255, 0.25);
}

.ai-assistant__send-btn:active:not(:disabled) {
  transform: scale(0.94);
}

.ai-assistant__send-btn:disabled {
  background: #e2e8f0;
  color: #94a3b8;
  box-shadow: none;
  cursor: not-allowed;
}

.ai-assistant__stop-btn {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border: none;
  border-radius: 12px;
  background: var(--ai-ink);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 6px;
  box-shadow: 0 8px 18px -6px rgba(15, 23, 42, 0.5);
  transition: background-color 0.2s var(--ai-ease), transform 0.15s var(--ai-ease);
}

.ai-assistant__stop-btn:hover {
  background: #000000;
}

.ai-assistant__stop-btn:active {
  transform: scale(0.94);
}

.ai-assistant__stop-icon {
  width: 12px;
  height: 12px;
  border-radius: 3px;
  background: #ffffff;
}

.ai-assistant__record-wrapper {
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-color: rgba(43, 57, 145, 0.3);
  box-shadow:
    0 0 0 4px rgba(43, 57, 145, 0.08),
    0 16px 36px -14px rgba(43, 57, 145, 0.3);
}

.ai-assistant__waveform {
  flex: 1 1;
  height: 40px;
  width: 100%;
  display: block;
}

.ai-assistant__record-btn {
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: background-color 0.2s var(--ai-ease), color 0.2s, transform 0.2s var(--ai-ease);
}

.ai-assistant__record-btn--cancel {
  background: #f1f5f9;
  color: var(--ai-ink-soft);
}

.ai-assistant__record-btn--cancel:hover {
  background: #fff1f2;
  color: #e11d48;
}

.ai-assistant__record-btn--confirm {
  background: var(--ai-gradient-rich);
  color: #ffffff;
  box-shadow: 0 8px 18px -6px rgba(43, 57, 145, 0.6);
}

.ai-assistant__record-btn--confirm:hover {
  transform: translateY(-1px);
}

.ai-assistant__hint {
  margin-top: 8px;
  text-align: center;
  font-size: 11px;
  color: var(--ai-ink-muted);
}

.ai-assistant__hint kbd {
  display: inline-block;
  padding: 1px 6px;
  font-family: inherit;
  font-size: 10.5px;
  font-weight: 600;
  color: var(--ai-ink-soft);
  background: #ffffff;
  border: 1px solid var(--ai-line);
  border-bottom-width: 2px;
  border-radius: 5px;
}

/* ---------- Drawer ---------- */

.ai-assistant-drawer__backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.32);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: 1200;
  animation: ai-assistant-fade 0.3s var(--ai-ease, ease-out);
}

.ai-assistant-drawer {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: min(580px, 94vw);
  z-index: 1201;
  background: #ffffff;
  border-radius: 0 22px 22px 0;
  overflow: hidden;
  box-shadow:
    24px 0 60px -12px rgba(15, 23, 42, 0.3),
    1px 0 0 rgba(15, 23, 42, 0.06);
  display: flex;
  flex-direction: column;
  animation: ai-assistant-slide-in 0.45s cubic-bezier(0.22, 1, 0.36, 1);
}

/* ---------- Header trigger ---------- */

.ai-assistant-trigger {
  border-radius: 8px;
  transition: background-color 0.25s ease;
  min-height: 28px;
  display: flex;
  align-items: center;
  padding: 2px 8px;
  cursor: pointer;
}

.ai-assistant-trigger:hover {
  background-color: rgba(43, 57, 145, 0.06);
}

.ai-assistant-trigger--active {
  background-color: rgba(43, 57, 145, 0.1);
}

.ai-assistant-trigger__icon {
  color: #2b3991;
  font-size: 0.9rem;
}

.ai-assistant-trigger__label {
  font-size: 0.8rem;
  color: #334155;
  font-weight: 500;
}

/* ---------- Scrollbars ---------- */

.ai-assistant__main::-webkit-scrollbar,
.ai-assistant__history-list::-webkit-scrollbar,
.ai-assistant__textarea::-webkit-scrollbar {
  width: 6px;
}

.ai-assistant__main::-webkit-scrollbar-track,
.ai-assistant__history-list::-webkit-scrollbar-track,
.ai-assistant__textarea::-webkit-scrollbar-track {
  background: transparent;
}

.ai-assistant__main::-webkit-scrollbar-thumb,
.ai-assistant__history-list::-webkit-scrollbar-thumb,
.ai-assistant__textarea::-webkit-scrollbar-thumb {
  background-color: rgba(15, 23, 42, 0.14);
  border-radius: 20px;
}

.ai-assistant__main::-webkit-scrollbar-thumb:hover {
  background-color: rgba(15, 23, 42, 0.24);
}

/* ---------- Animations ---------- */

@keyframes ai-assistant-rise {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes ai-assistant-line-reveal {
  from {
    opacity: 0;
    transform: translateY(4px);
    filter: blur(2px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
    filter: blur(0);
  }
}

@keyframes ai-assistant-pop {
  from {
    opacity: 0;
    transform: translateY(-6px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes ai-assistant-fade {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes ai-assistant-slide-in {
  from {
    transform: translateX(-100%);
    opacity: 0.6;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes ai-assistant-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
}

@keyframes ai-assistant-glow {
  0%, 100% {
    box-shadow:
      0 18px 40px -8px rgba(43, 57, 145, 0.5),
      0 0 0 0 rgba(79, 143, 240, 0.25),
      inset 0 1px 0 rgba(255, 255, 255, 0.3);
  }
  50% {
    box-shadow:
      0 22px 48px -8px rgba(43, 57, 145, 0.6),
      0 0 0 12px rgba(79, 143, 240, 0),
      inset 0 1px 0 rgba(255, 255, 255, 0.3);
  }
}

@keyframes ai-assistant-pulse {
  0% { transform: scale(1); opacity: 0.6; }
  80%, 100% { transform: scale(2.6); opacity: 0; }
}

@keyframes ai-assistant-cursor-pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.35; transform: scale(0.7); }
}

@keyframes ai-assistant-shimmer {
  from { background-position: 200% 0; }
  to { background-position: -200% 0; }
}

@keyframes ai-assistant-think-dot {
  0%, 100% { opacity: 0.25; transform: translateY(0); }
  40% { opacity: 1; transform: translateY(-3px); }
}

@media (max-width: 480px) {
  .ai-assistant__suggestions {
    grid-template-columns: 1fr;
  }

  .ai-assistant__chat-wrapper {
    padding: 0 16px 8px;
  }

  .ai-assistant-drawer {
    border-radius: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .ai-assistant *,
  .ai-assistant-drawer,
  .ai-assistant-drawer__backdrop {
    animation-duration: 0.01ms !important;
    transition-duration: 0.01ms !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AiAssistant/AiAssistant.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,6EAA6E;EAC7E,kFAAkF;EAClF,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,iCAAiC;EACjC,qBAAqB;EACrB,yCAAyC;;EAEzC,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,uFAAuF;EACvF,mCAAmC;EACnC,gBAAgB;EAChB;;;qDAGmD;AACrD;;AAEA,iCAAiC;;AAEjC;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,YAAY;EACZ,cAAc;EACd,qCAAqC;EACrC,0CAA0C;EAC1C,kDAAkD;EAClD,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,eAAe;EACf,mCAAmC;EACnC;;2CAEyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,mBAAmB;EACnB,oCAAoC;EACpC,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,4CAA4C;EAC5C;;;;;mCAKiC;AACnC;;AAEA;;EAEE,mBAAmB;EACnB,wBAAwB;EACxB,qCAAqC;EACrC,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;EAC5C,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,qDAAqD;EACrD,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iEAAiE;AACnE;;AAEA,wCAAwC;;AAExC;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,qCAAqC;EACrC,4BAA4B;EAC5B,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,gCAAgC;EAChC,mBAAmB;EACnB;;qCAEmC;EACnC,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,wBAAwB;EACxB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,UAAU;EACV,0EAA0E;AAC5E;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,sCAAsC;;AAEtC;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,WAAW;EACX,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA,kCAAkC;;AAElC;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,mCAAmC;EACnC;;0CAEwC;EACxC;;+CAE6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,0EAA0E;EAC1E,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,qCAAqC;EACrC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4CAA4C;EAC5C,UAAU;EACV,0DAA0D;EAC1D;;;;wCAIsC;AACxC;;AAEA,yCAAyC,sBAAsB,EAAE;AACjE,yCAAyC,sBAAsB,EAAE;AACjE,yCAAyC,qBAAqB,EAAE;AAChE,yCAAyC,sBAAsB,EAAE;;AAEjE;EACE,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,wBAAwB;EACxB,qFAAqF;EACrF,qEAAqE;AACvE;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,UAAU;EACV,+BAA+B;EAC/B,kFAAkF;AACpF;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA,mCAAmC;;AAEnC;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,wEAAwE;AAC1E;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,2EAA2E;AAC7E;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,cAAc;EACd,mCAAmC;EACnC,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,iBAAiB;EACjB,cAAc;EACd;;2CAEyC;AAC3C;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,gCAAgC;EAChC;;2CAEyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,wDAAwD;EACxD,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,gCAAgC,eAAe,EAAE;AACjD,gCAAgC,eAAe,EAAE;AACjD,gCAAgC,iBAAiB,EAAE;AACnD,gCAAgC,iBAAiB,EAAE;;AAEnD;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,gBAAgB;EAChB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,8FAA8F;EAC9F,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,4DAA4D;AAC9D;;AAEA,mCAAmC;;AAEnC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yEAAyE;EACzE,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,kBAAkB;EAClB,oDAAoD;AACtD;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,2DAA2D;AAC7D;;AAEA,2CAA2C,qBAAqB,EAAE;AAClE,2CAA2C,qBAAqB,EAAE;;AAElE,4CAA4C;;AAE5C;EACE,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,2EAA2E;AAC7E;;AAEA;;EAEE,6BAA6B;EAC7B,uCAAuC;EACvC,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb;;4CAE0C;EAC1C,4EAA4E;AAC9E;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC;;4CAE0C;AAC5C;;AAEA;EACE,SAAO;EACP,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,2EAA2E;AAC7E;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB;;2CAEyC;EACzC;;;;mCAIiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B;;2CAEyC;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iDAAiD;EACjD,gFAAgF;AAClF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,oCAAoC;EACpC;;4CAE0C;AAC5C;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2FAA2F;AAC7F;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gCAAgC;EAChC,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,iCAAiC;;AAEjC;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,0DAA0D;AAC5D;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB;;kCAEgC;EAChC,aAAa;EACb,sBAAsB;EACtB,qEAAqE;AACvE;;AAEA,yCAAyC;;AAEzC;EACE,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,qCAAqC;;AAErC;;;EAGE,UAAU;AACZ;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;;;EAGE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,qCAAqC;;AAErC;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;IAC1B,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,wBAAwB;IACxB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,4BAA4B;IAC5B,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE;IACE;;;4CAGwC;EAC1C;EACA;IACE;;;4CAGwC;EAC1C;AACF;;AAEA;EACE,KAAK,mBAAmB,EAAE,YAAY,EAAE;EACxC,YAAY,qBAAqB,EAAE,UAAU,EAAE;AACjD;;AAEA;EACE,WAAW,UAAU,EAAE,mBAAmB,EAAE;EAC5C,MAAM,aAAa,EAAE,qBAAqB,EAAE;AAC9C;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,KAAK,4BAA4B,EAAE;AACrC;;AAEA;EACE,WAAW,aAAa,EAAE,wBAAwB,EAAE;EACpD,MAAM,UAAU,EAAE,2BAA2B,EAAE;AACjD;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;;;IAGE,qCAAqC;IACrC,sCAAsC;EACxC;AACF","sourcesContent":[".ai-assistant {\n  --ai-brand-1: #2b3991;\n  --ai-brand-2: #1e71bb;\n  --ai-brand-3: #6d5dfc;\n  --ai-gradient: linear-gradient(135deg, #2b3991 0%, #1e71bb 55%, #4f8ff0 100%);\n  --ai-gradient-rich: linear-gradient(135deg, #1f2a78 0%, #3b3fc4 45%, #1e71bb 100%);\n  --ai-ink: #0f172a;\n  --ai-ink-soft: #475569;\n  --ai-ink-muted: #94a3b8;\n  --ai-line: rgba(15, 23, 42, 0.08);\n  --ai-surface: #ffffff;\n  --ai-ease: cubic-bezier(0.22, 1, 0.36, 1);\n\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  color: var(--ai-ink);\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  overflow: hidden;\n  background:\n    radial-gradient(900px 420px at 0% -10%, rgba(79, 143, 240, 0.14), transparent 60%),\n    radial-gradient(700px 380px at 110% 10%, rgba(109, 93, 252, 0.12), transparent 60%),\n    linear-gradient(180deg, #f8faff 0%, #f3f5fb 100%);\n}\n\n/* ---------- Header ---------- */\n\n.ai-assistant__header {\n  position: relative;\n  z-index: 5;\n  padding: 0 20px;\n  height: 68px;\n  flex-shrink: 0;\n  background: rgba(255, 255, 255, 0.72);\n  backdrop-filter: saturate(180%) blur(16px);\n  -webkit-backdrop-filter: saturate(180%) blur(16px);\n  border-bottom: 1px solid var(--ai-line);\n}\n\n.ai-assistant__header-content {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.ai-assistant__logo-area {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n  flex: 1;\n}\n\n.ai-assistant__logo-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: #ffffff;\n  font-size: 18px;\n  background: var(--ai-gradient-rich);\n  box-shadow:\n    0 6px 16px rgba(43, 57, 145, 0.35),\n    inset 0 1px 0 rgba(255, 255, 255, 0.25);\n}\n\n.ai-assistant__logo-text-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 0;\n}\n\n.ai-assistant__logo-text {\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: var(--ai-ink);\n  line-height: 1.2;\n}\n\n.ai-assistant__online {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11.5px;\n  font-weight: 500;\n  color: #059669;\n  line-height: 1;\n}\n\n.ai-assistant__online-dot {\n  position: relative;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #10b981;\n}\n\n.ai-assistant__online-dot::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  background: #10b981;\n  animation: ai-assistant-pulse 2s var(--ai-ease) infinite;\n}\n\n.ai-assistant__header-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.ai-assistant__history-wrap {\n  position: relative;\n}\n\n.ai-assistant__history-btn,\n.ai-assistant__close-btn {\n  width: 38px;\n  height: 38px;\n  border: 1px solid var(--ai-line);\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.9);\n  color: var(--ai-ink-soft);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 15px;\n  flex-shrink: 0;\n  padding: 0;\n  position: relative;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  transition:\n    background-color 0.25s var(--ai-ease),\n    color 0.25s var(--ai-ease),\n    border-color 0.25s var(--ai-ease),\n    transform 0.25s var(--ai-ease),\n    box-shadow 0.25s var(--ai-ease);\n}\n\n.ai-assistant__history-btn:hover,\n.ai-assistant__history-btn--active {\n  background: #ffffff;\n  color: var(--ai-brand-1);\n  border-color: rgba(43, 57, 145, 0.22);\n  box-shadow: 0 6px 16px rgba(43, 57, 145, 0.12);\n  transform: translateY(-1px);\n}\n\n.ai-assistant__close-btn:hover {\n  background: #ffffff;\n  color: var(--ai-ink);\n  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.1);\n  transform: translateY(-1px) rotate(90deg);\n}\n\n.ai-assistant__history-badge {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  border-radius: 999px;\n  background: linear-gradient(135deg, #f43f5e, #e11d48);\n  color: #ffffff;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 18px;\n  text-align: center;\n  box-shadow: 0 0 0 2px #ffffff, 0 4px 10px rgba(225, 29, 72, 0.35);\n}\n\n/* ---------- History panel ---------- */\n\n.ai-assistant__history-panel {\n  position: absolute;\n  top: calc(100% + 10px);\n  right: 0;\n  width: min(340px, calc(100vw - 48px));\n  max-height: min(400px, 60vh);\n  background: rgba(255, 255, 255, 0.96);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid var(--ai-line);\n  border-radius: 16px;\n  box-shadow:\n    0 24px 48px -12px rgba(15, 23, 42, 0.22),\n    0 4px 12px rgba(15, 23, 42, 0.06);\n  z-index: 30;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  transform-origin: top right;\n  animation: ai-assistant-pop 0.28s var(--ai-ease);\n}\n\n.ai-assistant__history-panel-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--ai-line);\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--ai-ink);\n}\n\n.ai-assistant__history-clear {\n  border: none;\n  background: rgba(43, 57, 145, 0.08);\n  color: var(--ai-brand-1);\n  font-size: 11.5px;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 5px 10px;\n  border-radius: 999px;\n  transition: background-color 0.2s var(--ai-ease);\n}\n\n.ai-assistant__history-clear:hover {\n  background: rgba(43, 57, 145, 0.14);\n}\n\n.ai-assistant__history-empty {\n  padding: 28px 16px;\n  font-size: 12.5px;\n  color: var(--ai-ink-muted);\n  text-align: center;\n  line-height: 1.6;\n}\n\n.ai-assistant__history-list {\n  list-style: none;\n  margin: 0;\n  padding: 8px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.ai-assistant__history-item {\n  display: flex;\n  align-items: stretch;\n  gap: 2px;\n  border-radius: 10px;\n  transition: background-color 0.2s var(--ai-ease);\n}\n\n.ai-assistant__history-item:hover {\n  background: rgba(43, 57, 145, 0.05);\n}\n\n.ai-assistant__history-item-main {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  background: transparent;\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 10px;\n  cursor: pointer;\n  text-align: left;\n  color: inherit;\n}\n\n.ai-assistant__history-item-main:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.ai-assistant__history-item-main > i {\n  width: 26px;\n  height: 26px;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(43, 57, 145, 0.08);\n  color: var(--ai-brand-1);\n  font-size: 11px;\n  flex-shrink: 0;\n}\n\n.ai-assistant__history-item-body {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 0;\n}\n\n.ai-assistant__history-item-text {\n  font-size: 12.5px;\n  font-weight: 500;\n  color: var(--ai-ink);\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.ai-assistant__history-item-time {\n  font-size: 10.5px;\n  color: var(--ai-ink-muted);\n}\n\n.ai-assistant__history-item-remove {\n  width: 30px;\n  border: none;\n  background: transparent;\n  color: var(--ai-ink-muted);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  flex-shrink: 0;\n  padding: 0;\n  opacity: 0;\n  transition: opacity 0.2s var(--ai-ease), color 0.2s, background-color 0.2s;\n}\n\n.ai-assistant__history-item:hover .ai-assistant__history-item-remove {\n  opacity: 1;\n}\n\n.ai-assistant__history-item-remove:hover {\n  color: #e11d48;\n  background: #fff1f2;\n}\n\n/* ---------- Main / chat ---------- */\n\n.ai-assistant__main {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  display: flex;\n  justify-content: center;\n  padding: 28px 0 12px;\n  width: 100%;\n  overscroll-behavior: contain;\n  scroll-behavior: smooth;\n}\n\n.ai-assistant__chat-wrapper {\n  width: 100%;\n  max-width: 720px;\n  padding: 0 24px 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 22px;\n}\n\n.ai-assistant__footer > form,\n.ai-assistant__header-content {\n  max-width: 720px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n/* ---------- Welcome ---------- */\n\n.ai-assistant__welcome {\n  min-height: 58vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  padding: 12px 4px;\n  animation: ai-assistant-rise 0.6s var(--ai-ease);\n}\n\n.ai-assistant__welcome-icon {\n  position: relative;\n  width: 76px;\n  height: 76px;\n  border-radius: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 26px;\n  color: #ffffff;\n  font-size: 32px;\n  background: var(--ai-gradient-rich);\n  box-shadow:\n    0 18px 40px -8px rgba(43, 57, 145, 0.5),\n    inset 0 1px 0 rgba(255, 255, 255, 0.3);\n  animation:\n    ai-assistant-float 5s ease-in-out infinite,\n    ai-assistant-glow 3.2s ease-in-out infinite;\n}\n\n.ai-assistant__welcome-title {\n  font-size: 26px;\n  font-weight: 700;\n  letter-spacing: -0.03em;\n  margin: 0 0 10px;\n  line-height: 1.2;\n  background: linear-gradient(135deg, #0f172a 0%, #2b3991 60%, #1e71bb 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  color: transparent;\n}\n\n.ai-assistant__welcome-subtitle {\n  margin: 0;\n  max-width: 440px;\n  font-size: 14px;\n  line-height: 1.65;\n  color: var(--ai-ink-soft);\n}\n\n.ai-assistant__welcome-subtitle strong {\n  color: var(--ai-brand-1);\n  font-weight: 600;\n}\n\n.ai-assistant__suggestions {\n  margin-top: 28px;\n  width: 100%;\n  max-width: 480px;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.ai-assistant__suggestion {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  text-align: left;\n  border: 1px solid var(--ai-line);\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.85);\n  color: var(--ai-ink);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  opacity: 0;\n  animation: ai-assistant-rise 0.55s var(--ai-ease) forwards;\n  transition:\n    transform 0.3s var(--ai-ease),\n    box-shadow 0.3s var(--ai-ease),\n    border-color 0.3s var(--ai-ease),\n    background-color 0.3s var(--ai-ease);\n}\n\n.ai-assistant__suggestion:nth-child(1) { animation-delay: 0.08s; }\n.ai-assistant__suggestion:nth-child(2) { animation-delay: 0.14s; }\n.ai-assistant__suggestion:nth-child(3) { animation-delay: 0.2s; }\n.ai-assistant__suggestion:nth-child(4) { animation-delay: 0.26s; }\n\n.ai-assistant__suggestion:hover {\n  background: #ffffff;\n  border-color: rgba(43, 57, 145, 0.22);\n  transform: translateY(-2px);\n  box-shadow: 0 12px 24px -8px rgba(43, 57, 145, 0.22);\n}\n\n.ai-assistant__suggestion-icon {\n  width: 30px;\n  height: 30px;\n  border-radius: 9px;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  color: var(--ai-brand-1);\n  background: linear-gradient(135deg, rgba(43, 57, 145, 0.1), rgba(30, 113, 187, 0.12));\n  transition: background 0.3s var(--ai-ease), color 0.3s var(--ai-ease);\n}\n\n.ai-assistant__suggestion:hover .ai-assistant__suggestion-icon {\n  background: var(--ai-gradient);\n  color: #ffffff;\n}\n\n.ai-assistant__suggestion-text {\n  flex: 1;\n  min-width: 0;\n  line-height: 1.35;\n}\n\n.ai-assistant__suggestion-arrow {\n  font-size: 12px;\n  color: var(--ai-ink-muted);\n  opacity: 0;\n  transform: translate(-4px, 4px);\n  transition: opacity 0.3s var(--ai-ease), transform 0.3s var(--ai-ease), color 0.3s;\n}\n\n.ai-assistant__suggestion:hover .ai-assistant__suggestion-arrow {\n  opacity: 1;\n  color: var(--ai-brand-1);\n  transform: translate(0, 0);\n}\n\n/* ---------- Messages ---------- */\n\n.ai-assistant__message-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  animation: ai-assistant-rise 0.45s var(--ai-ease);\n}\n\n.ai-assistant__message-row--user {\n  justify-content: flex-end;\n  align-items: flex-end;\n}\n\n.ai-assistant__message-row--ai {\n  justify-content: flex-start;\n}\n\n.ai-assistant__message-content {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-width: 85%;\n  min-width: 0;\n}\n\n.ai-assistant__message-content--user {\n  align-items: flex-end;\n}\n\n.ai-assistant__msg-actions {\n  display: flex;\n  gap: 2px;\n  padding-right: 2px;\n  opacity: 0;\n  transform: translateY(-2px);\n  transition: opacity 0.25s var(--ai-ease), transform 0.25s var(--ai-ease);\n}\n\n.ai-assistant__message-row--user:hover .ai-assistant__msg-actions {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.ai-assistant__msg-actions--ai {\n  opacity: 1;\n  transform: none;\n  padding-left: 2px;\n}\n\n.ai-assistant__action-btn {\n  width: 30px;\n  height: 30px;\n  border: none;\n  border-radius: 9px;\n  background: transparent;\n  color: var(--ai-ink-muted);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  padding: 0;\n  transition: background-color 0.2s var(--ai-ease), color 0.2s var(--ai-ease);\n}\n\n.ai-assistant__action-btn:hover {\n  background-color: rgba(43, 57, 145, 0.08);\n  color: var(--ai-brand-1);\n}\n\n.ai-assistant__action-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.ai-assistant__label {\n  font-size: 11.5px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  color: var(--ai-ink-muted);\n  padding-left: 4px;\n}\n\n.ai-assistant__label--user {\n  text-align: right;\n  padding-right: 4px;\n}\n\n.ai-assistant__label--ai {\n  color: var(--ai-brand-1);\n}\n\n.ai-assistant__avatar {\n  width: 34px;\n  height: 34px;\n  border-radius: 11px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 15px;\n  flex-shrink: 0;\n  color: #ffffff;\n  background: var(--ai-gradient-rich);\n  box-shadow: 0 6px 14px -4px rgba(43, 57, 145, 0.45);\n}\n\n.ai-assistant__bubble {\n  padding: 13px 18px;\n  border-radius: 20px 20px 20px 6px;\n  max-width: 100%;\n  font-size: 14.5px;\n  line-height: 1.65;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.ai-assistant__bubble--user {\n  background: var(--ai-gradient);\n  border-radius: 20px 20px 6px 20px;\n  line-height: 1.55;\n  color: #ffffff;\n  box-shadow:\n    0 10px 24px -8px rgba(43, 57, 145, 0.5),\n    inset 0 1px 0 rgba(255, 255, 255, 0.18);\n}\n\n.ai-assistant__bubble--ai {\n  background: var(--ai-surface);\n  color: var(--ai-ink);\n  border: 1px solid var(--ai-line);\n  box-shadow:\n    0 1px 2px rgba(15, 23, 42, 0.04),\n    0 8px 24px -12px rgba(15, 23, 42, 0.12);\n}\n\n.ai-assistant__typewriter {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.ai-assistant__typewriter-line {\n  animation: ai-assistant-line-reveal 0.35s var(--ai-ease);\n  line-height: 1.65;\n}\n\n.ai-assistant__md-heading {\n  font-weight: 700;\n  letter-spacing: -0.015em;\n  color: var(--ai-ink);\n  margin: 8px 0 4px;\n  line-height: 1.35;\n}\n\n.ai-assistant__md-heading--h1 { font-size: 19px; }\n.ai-assistant__md-heading--h2 { font-size: 17px; }\n.ai-assistant__md-heading--h3 { font-size: 15.5px; }\n.ai-assistant__md-heading--h4 { font-size: 14.5px; }\n\n.ai-assistant__md-paragraph {\n  font-size: 14.5px;\n  line-height: 1.65;\n  color: #1e293b;\n}\n\n.ai-assistant__md-paragraph strong,\n.ai-assistant__md-bullet strong {\n  color: var(--ai-ink);\n  font-weight: 650;\n}\n\n.ai-assistant__md-bullet {\n  display: flex;\n  gap: 10px;\n  font-size: 14.5px;\n  line-height: 1.65;\n  color: #1e293b;\n  padding-left: 2px;\n}\n\n.ai-assistant__md-bullet-dot {\n  flex-shrink: 0;\n  width: 6px;\n  height: 6px;\n  margin-top: 0.62em;\n  border-radius: 50%;\n  background: var(--ai-gradient);\n  font-size: 0;\n}\n\n.ai-assistant__md-bullet-num {\n  color: var(--ai-brand-1);\n  flex-shrink: 0;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  line-height: 1.65;\n}\n\n.ai-assistant__md-bullet-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.ai-assistant__md-spacer {\n  height: 8px;\n}\n\n.ai-assistant__inline-code {\n  background-color: rgba(43, 57, 145, 0.06);\n  border: 1px solid rgba(43, 57, 145, 0.12);\n  border-radius: 6px;\n  padding: 1px 6px;\n  font-family: \"JetBrains Mono\", \"SFMono-Regular\", Consolas, \"Liberation Mono\", Menlo, monospace;\n  font-size: 12.5px;\n  color: #3b3fc4;\n}\n\n.ai-assistant__cursor {\n  display: inline-block;\n  width: 7px;\n  height: 7px;\n  margin: 6px 0 0 2px;\n  border-radius: 50%;\n  background: var(--ai-gradient);\n  animation: ai-assistant-cursor-pulse 1s ease-in-out infinite;\n}\n\n/* ---------- Thinking ---------- */\n\n.ai-assistant__thinking {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.ai-assistant__thinking-text {\n  font-size: 14px;\n  font-weight: 500;\n  background: linear-gradient(90deg, #b6c0d4 20%, #2b3991 50%, #b6c0d4 80%);\n  background-size: 200% 100%;\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  color: transparent;\n  animation: ai-assistant-shimmer 1.8s linear infinite;\n}\n\n.ai-assistant__thinking-dots {\n  display: inline-flex;\n  align-items: flex-end;\n  gap: 4px;\n  margin-left: 6px;\n  padding-bottom: 3px;\n}\n\n.ai-assistant__thinking-dot {\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background: var(--ai-gradient);\n  opacity: 0.35;\n  animation: ai-assistant-think-dot 1.4s ease-in-out infinite;\n}\n\n.ai-assistant__thinking-dot:nth-child(2) { animation-delay: 0.2s; }\n.ai-assistant__thinking-dot:nth-child(3) { animation-delay: 0.4s; }\n\n/* ---------- Footer / composer ---------- */\n\n.ai-assistant__footer {\n  position: relative;\n  padding: 10px 18px 14px;\n  flex-shrink: 0;\n  background: linear-gradient(180deg, rgba(243, 245, 251, 0) 0%, #f3f5fb 40%);\n}\n\n.ai-assistant__input-wrapper,\n.ai-assistant__record-wrapper {\n  background: var(--ai-surface);\n  border: 1px solid rgba(15, 23, 42, 0.1);\n  border-radius: 20px;\n  padding: 8px;\n  display: flex;\n  box-shadow:\n    0 1px 2px rgba(15, 23, 42, 0.04),\n    0 16px 36px -14px rgba(15, 23, 42, 0.18);\n  transition: border-color 0.3s var(--ai-ease), box-shadow 0.3s var(--ai-ease);\n}\n\n.ai-assistant__input-wrapper {\n  align-items: flex-end;\n}\n\n.ai-assistant__input-wrapper:focus-within {\n  border-color: rgba(43, 57, 145, 0.35);\n  box-shadow:\n    0 0 0 4px rgba(43, 57, 145, 0.08),\n    0 16px 36px -14px rgba(43, 57, 145, 0.3);\n}\n\n.ai-assistant__textarea {\n  flex: 1;\n  background-color: transparent;\n  border: none;\n  outline: none;\n  color: var(--ai-ink);\n  font-size: 14.5px;\n  resize: none;\n  padding: 10px 12px;\n  font-family: inherit;\n  line-height: 1.5;\n  max-height: 140px;\n  overflow-y: auto;\n}\n\n.ai-assistant__textarea::placeholder {\n  color: var(--ai-ink-muted);\n}\n\n.ai-assistant__mic-btn {\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  border: none;\n  border-radius: 12px;\n  background: transparent;\n  color: var(--ai-ink-soft);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 17px;\n  margin-left: 4px;\n  transition: background-color 0.2s var(--ai-ease), color 0.2s var(--ai-ease);\n}\n\n.ai-assistant__mic-btn:hover {\n  background: rgba(43, 57, 145, 0.08);\n  color: var(--ai-brand-1);\n}\n\n.ai-assistant__send-btn {\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--ai-gradient-rich);\n  color: #ffffff;\n  border: none;\n  border-radius: 12px;\n  font-size: 17px;\n  cursor: pointer;\n  margin-left: 6px;\n  box-shadow:\n    0 8px 18px -6px rgba(43, 57, 145, 0.6),\n    inset 0 1px 0 rgba(255, 255, 255, 0.25);\n  transition:\n    transform 0.25s var(--ai-ease),\n    box-shadow 0.25s var(--ai-ease),\n    opacity 0.25s var(--ai-ease),\n    background 0.25s var(--ai-ease);\n}\n\n.ai-assistant__send-btn:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow:\n    0 12px 22px -6px rgba(43, 57, 145, 0.7),\n    inset 0 1px 0 rgba(255, 255, 255, 0.25);\n}\n\n.ai-assistant__send-btn:active:not(:disabled) {\n  transform: scale(0.94);\n}\n\n.ai-assistant__send-btn:disabled {\n  background: #e2e8f0;\n  color: #94a3b8;\n  box-shadow: none;\n  cursor: not-allowed;\n}\n\n.ai-assistant__stop-btn {\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  border: none;\n  border-radius: 12px;\n  background: var(--ai-ink);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 6px;\n  box-shadow: 0 8px 18px -6px rgba(15, 23, 42, 0.5);\n  transition: background-color 0.2s var(--ai-ease), transform 0.15s var(--ai-ease);\n}\n\n.ai-assistant__stop-btn:hover {\n  background: #000000;\n}\n\n.ai-assistant__stop-btn:active {\n  transform: scale(0.94);\n}\n\n.ai-assistant__stop-icon {\n  width: 12px;\n  height: 12px;\n  border-radius: 3px;\n  background: #ffffff;\n}\n\n.ai-assistant__record-wrapper {\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  border-color: rgba(43, 57, 145, 0.3);\n  box-shadow:\n    0 0 0 4px rgba(43, 57, 145, 0.08),\n    0 16px 36px -14px rgba(43, 57, 145, 0.3);\n}\n\n.ai-assistant__waveform {\n  flex: 1;\n  height: 40px;\n  width: 100%;\n  display: block;\n}\n\n.ai-assistant__record-btn {\n  width: 38px;\n  height: 38px;\n  flex-shrink: 0;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  transition: background-color 0.2s var(--ai-ease), color 0.2s, transform 0.2s var(--ai-ease);\n}\n\n.ai-assistant__record-btn--cancel {\n  background: #f1f5f9;\n  color: var(--ai-ink-soft);\n}\n\n.ai-assistant__record-btn--cancel:hover {\n  background: #fff1f2;\n  color: #e11d48;\n}\n\n.ai-assistant__record-btn--confirm {\n  background: var(--ai-gradient-rich);\n  color: #ffffff;\n  box-shadow: 0 8px 18px -6px rgba(43, 57, 145, 0.6);\n}\n\n.ai-assistant__record-btn--confirm:hover {\n  transform: translateY(-1px);\n}\n\n.ai-assistant__hint {\n  margin-top: 8px;\n  text-align: center;\n  font-size: 11px;\n  color: var(--ai-ink-muted);\n}\n\n.ai-assistant__hint kbd {\n  display: inline-block;\n  padding: 1px 6px;\n  font-family: inherit;\n  font-size: 10.5px;\n  font-weight: 600;\n  color: var(--ai-ink-soft);\n  background: #ffffff;\n  border: 1px solid var(--ai-line);\n  border-bottom-width: 2px;\n  border-radius: 5px;\n}\n\n/* ---------- Drawer ---------- */\n\n.ai-assistant-drawer__backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.32);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  z-index: 1200;\n  animation: ai-assistant-fade 0.3s var(--ai-ease, ease-out);\n}\n\n.ai-assistant-drawer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: min(580px, 94vw);\n  z-index: 1201;\n  background: #ffffff;\n  border-radius: 0 22px 22px 0;\n  overflow: hidden;\n  box-shadow:\n    24px 0 60px -12px rgba(15, 23, 42, 0.3),\n    1px 0 0 rgba(15, 23, 42, 0.06);\n  display: flex;\n  flex-direction: column;\n  animation: ai-assistant-slide-in 0.45s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n/* ---------- Header trigger ---------- */\n\n.ai-assistant-trigger {\n  border-radius: 8px;\n  transition: background-color 0.25s ease;\n  min-height: 28px;\n  display: flex;\n  align-items: center;\n  padding: 2px 8px;\n  cursor: pointer;\n}\n\n.ai-assistant-trigger:hover {\n  background-color: rgba(43, 57, 145, 0.06);\n}\n\n.ai-assistant-trigger--active {\n  background-color: rgba(43, 57, 145, 0.1);\n}\n\n.ai-assistant-trigger__icon {\n  color: #2b3991;\n  font-size: 0.9rem;\n}\n\n.ai-assistant-trigger__label {\n  font-size: 0.8rem;\n  color: #334155;\n  font-weight: 500;\n}\n\n/* ---------- Scrollbars ---------- */\n\n.ai-assistant__main::-webkit-scrollbar,\n.ai-assistant__history-list::-webkit-scrollbar,\n.ai-assistant__textarea::-webkit-scrollbar {\n  width: 6px;\n}\n\n.ai-assistant__main::-webkit-scrollbar-track,\n.ai-assistant__history-list::-webkit-scrollbar-track,\n.ai-assistant__textarea::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.ai-assistant__main::-webkit-scrollbar-thumb,\n.ai-assistant__history-list::-webkit-scrollbar-thumb,\n.ai-assistant__textarea::-webkit-scrollbar-thumb {\n  background-color: rgba(15, 23, 42, 0.14);\n  border-radius: 20px;\n}\n\n.ai-assistant__main::-webkit-scrollbar-thumb:hover {\n  background-color: rgba(15, 23, 42, 0.24);\n}\n\n/* ---------- Animations ---------- */\n\n@keyframes ai-assistant-rise {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes ai-assistant-line-reveal {\n  from {\n    opacity: 0;\n    transform: translateY(4px);\n    filter: blur(2px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n    filter: blur(0);\n  }\n}\n\n@keyframes ai-assistant-pop {\n  from {\n    opacity: 0;\n    transform: translateY(-6px) scale(0.97);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes ai-assistant-fade {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes ai-assistant-slide-in {\n  from {\n    transform: translateX(-100%);\n    opacity: 0.6;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n@keyframes ai-assistant-float {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-6px); }\n}\n\n@keyframes ai-assistant-glow {\n  0%, 100% {\n    box-shadow:\n      0 18px 40px -8px rgba(43, 57, 145, 0.5),\n      0 0 0 0 rgba(79, 143, 240, 0.25),\n      inset 0 1px 0 rgba(255, 255, 255, 0.3);\n  }\n  50% {\n    box-shadow:\n      0 22px 48px -8px rgba(43, 57, 145, 0.6),\n      0 0 0 12px rgba(79, 143, 240, 0),\n      inset 0 1px 0 rgba(255, 255, 255, 0.3);\n  }\n}\n\n@keyframes ai-assistant-pulse {\n  0% { transform: scale(1); opacity: 0.6; }\n  80%, 100% { transform: scale(2.6); opacity: 0; }\n}\n\n@keyframes ai-assistant-cursor-pulse {\n  0%, 100% { opacity: 1; transform: scale(1); }\n  50% { opacity: 0.35; transform: scale(0.7); }\n}\n\n@keyframes ai-assistant-shimmer {\n  from { background-position: 200% 0; }\n  to { background-position: -200% 0; }\n}\n\n@keyframes ai-assistant-think-dot {\n  0%, 100% { opacity: 0.25; transform: translateY(0); }\n  40% { opacity: 1; transform: translateY(-3px); }\n}\n\n@media (max-width: 480px) {\n  .ai-assistant__suggestions {\n    grid-template-columns: 1fr;\n  }\n\n  .ai-assistant__chat-wrapper {\n    padding: 0 16px 8px;\n  }\n\n  .ai-assistant-drawer {\n    border-radius: 0;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .ai-assistant *,\n  .ai-assistant-drawer,\n  .ai-assistant-drawer__backdrop {\n    animation-duration: 0.01ms !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
